<template>
    <div id="parallax-world-of-ugg">
       <br>
    <section>
     <div class="img">
       <img class="" src="/cloud_irecall_logo.png" alt="img">
     </div>
     <br>
     <div class="page-break"></div>
     <div class="block">
      <div class="content">
    <p class="start-info">
      With more and more businesses moving their software and data storage to the cloud, 
      iReCall stands out as the all-in-one, future-ready solution for professional call recording.
    </p>

    <br>

    <ul>

      <li>
        Designed with flexibility and performance in mind, it offers 
        <span class="highlight">access to specialist skills on-demand</span>, ensuring expert support is always within reach.
      </li>
      <br>
      <li>
         Your data is <span class="highlight">fully secure and easily accessible</span>, thanks to enterprise-level encryption and cloud-based convenience. 
      </li>
      <br>
  
      <li>
         You'll always be ahead of the curve with <span class="highlight">the latest software — always up to date</span>, requiring no manual maintenance. 
      </li>
      <br>
  
      <li>
         Our <span class="highlight">straightforward, affordable billing</span> keeps things simple, with clear pricing tailored to your needs. 
      </li>
      <br>
  
      <li>
         And to support continuous improvement, <span class="highlight">Agent Quality Management (AQM)</span> tools are built right in, 
        helping you monitor, evaluate, and enhance agent performance with ease.
      </li>
    </ul>
    <br>
    <br>
    <h4>Your reasons for switching to iReCall are clear…</h4>
    <br>
    <div id="circle-shape-example" style="text-align: justify;
  text-justify: inter-word;">
  <img src="/Irecall round image.jpg" alt="pic" class="curve"> <p class="main-info">
      <span>ACCESS TO SPECIALIST SKILLS – ON-DEMAND</span> We manage your complete call recording function on your behalf, which means that you never need to worry about employing specialised skills.</p> <p class="main-info">You can increase or decrease the number of users you require monthly, as you need. <span>FULLY SECURE, EASILY ACCESSIBLE DATA</span> Storing and safeguarding your call recording data can now become a worry of the past.</p> <p class="main-info">Calls are captured and then automatically uploaded to our cloud-based server either in real-time, or according to scheduled times as you prefer. You have 24/7 access to your call recordings, which we secure in the cloud for 5 years. <span>THE LATEST SOFTWARE – ALWAYS!</span> iReCall is offered as Software as a Service (SaaS), therefore, you need never worry about paying for another upgrade.</p> <p class="main-info">We ensure that you will have access to the most current version of the iReCall software at all times. <span>STRAIGHTFORWARD, AFFORDABLE BILLING</span> There are no Service Level Agreement (SLA) fees to worry about and you only pay per monitored device. Our month-to-month contracts mean that you are able to completely sidestep any financial risks for your business.</p> <p class="main-info">iReCall reflects only as operational expenditure (OPEX). <span>AGENT QUALITY MANAGEMENT (AQM)</span> iReCall includes the facility to create custom templates that can be used to store the service and performance data of individual agents. The AQM feature also allows for the random selection of recordings to be marked for scoring.</p> <p class="main-info">This ensures compliance with the requirements of your HR department, while an additional range of included reporting tools enables you to track and compare agent performance.</p>  
</div>
<br>
<h4>iReCall at a glance…
</h4>
<br>
    <p class="start-info">
      Power-packed with a wide range of features and capabilities, iReCall gives you all the tools you need to manage your call recording needs with exceptional ease. Our software has been designed to help you maximise both productivity and standards of service in your business.
    </p>
  <br>
  <div class="D1 section-flex">
          <img src="/iReCall Screenshot 1.png" alt="Recording" class="section-image"  loading="lazy" />
          <div>
            <h3>Recording <em> ~ Flexible & Intuitive</em> </h3>
            <ul>
              <li>Calls captured from anywhere and with any PABX.</li> 
              <li>Recording multiple remote branches with centralized access and storage of recordings.</li>
              <li>Flexibility in recording method topology (PRI, BRI, Analog, VoIP Trunks, plus Analog, Digital & VoIP Extensions).</li>
              <li>Channels multiple recording method combinations into a single iReCall account.</li>
            </ul>
          </div>
        </div>

        <br>
        <br>
        <br>
        <br>
        
      <div class="D2 section-flex">
        <div>
          <h3>Search & Playback <em> ~ Efficient & Powerful </em></h3>
          <ul> 
            <li>Quick and easy retrieval of calls for immediate query resolution.</li>
            <li>Time-scale display timeline with efficient playback capabilities.</li>
            <li>Access via any device to call recordings and reports.</li>
            <li>Enhanced search functions including Call Type, Number of Tags and Number of AQM Templates completed.</li>
            <li>Powerful, multi-level search, tagging and in-line note capabilities.</li>
            <li> No 3rd party plugins needed to search and listen to calls.</li>
          </ul>
        </div>
        <img src="/iReCall Screenshot 2.png" alt="Search and Playback" class="section-image"  loading="lazy" />
      </div>

        <br>
        <br>
        <br>
        <br>
        
      <div class="D3 section-flex">
        <img src="/iReCall Screenshot 3.png" alt="Storage" class="section-image"  loading="lazy" />
        <div>
          <h3>Data Storage <em> ~ Secure & Accessible </em></h3>
          <ul>
            <li>Cloud-based storage and backup of data.</li>
            <li>Provides optional cloud-based backup and storage solutions for enhanced data protection and accessibility.</li>
            <li>Efficient and safe recording data conversions, storage and access.</li>
          </ul>
        </div>
      </div>

        <br>
        <br>
        <br>
        <br>
        
        <div class="D5 section-flex">
          <div>
            <h3>Team Management <em> ~ Customised & Advanced </em></h3>
            <ul>
              <li>Unlimited, multi-level supervisor access at no additional cost.</li>
              <li>Individualised supervisor permissions for AQM, audit trails, dashboards, diagrams, additional modules, recording search, recording playback and more.</li>
              <li>Infinite groups and supervisor structures with multi-way group access for easy team management.</li>
              <li>Automated group structure diagrams for accurate group, supervisor and agent allocation.</li>
              <li>Custom AQM Template and Questionnaire setup and easy AQM Questionnaire sharing.</li>
              <li>Advanced Agent Status Review utilities.</li>
              <li>Full audit trails. Access to recordings, administration tasks and AQM tasks can be traced.</li>
              
            </ul>
          </div>
          <img src="/iReCall Screenshot 4.png" alt="Technical Management" class="section-image"  loading="lazy" />
        </div>
  
          <br>
          <br>
          <br>
          <br>

      <div class="D4 section-flex">
        <img src="/iReCall Screenshot 5.png" alt="Team Management" class="section-image"  loading="lazy" />
        <div>
          <h3>Technical Management <em> ~ Straightforward & Proactive </em></h3>
          <ul>
            <li>Hassle-free installation.</li>
            <li>Comprehensive internet based supervisor training.</li>
            <li>Ongoing software updates.</li>
            <li>Automated system health checks.</li>
            <li>Automated software health-checks and error reporting for proactive software management and resolution.</li>
            <li>Free, comprehensive Software Developer Integration Kit (SDK).</li>
            <li>Recording software can run on either a physical or virtual server.</li>
          </ul>
        </div>
      </div>

        <br>
        <br>
        <br>
        <br>

        
      <div class="D6 section-flex">
        <div>
          <h3>Intelligence & Reporting <em> ~ Comprehensive & Efficient </em></h3>
          <ul>
            <li>Flexible, comprehensive reports and statistics on all call recordings.</li>
            <li>Reports and statistics available per user, extension or telephone number.</li>
            <li>Advanced analysis and automated report generation.</li>
            <li>Quick, automated report distribution via secure email.</li>
            <li>Advanced supervisor auto-logout feature.</li>
            <li>Playback link with access to a specific recording can be sent that will be available for a limited time.</li>
          </ul>
        </div>
        <img src="/iReCall Screenshot 7.png" alt="Intelligence and Reporting" class="section-image" />
      </div>

        <br>
        <br>
        <br>

        <div class="D7 section-flex">
        <img src="/iReCall Screenshot 6.png" alt="Compliance" class="section-image" />
        <div>
          <h3>Compliance <em> ~ Extensive & Current </em></h3>
          <ul>
            <li>Full compliance with POPI, FICA, FAIS, SOX, PCI, NCA and CPA requirements.</li>
            <li>Automatic detection and masking of DTMF tones for POPI compliancy.</li>
            <li>Mute sensitive or non-essential information in the recording before it is emailed or exported.</li>
          </ul>
        </div>
      </div>
    </div>
    <br>
    <br>

          <div class="buttton">
        <div class="button" @click.prevent="openModal('promotion')"  data-tooltip="Please Click" >
      <div class="button-wrapper">
        <div class="text">iReCall Brochures</div>
          <span class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="2em" height="2em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17"></path></svg>
          </span>
        </div>
      </div>
    
      <!-- Modal -->
    <div v-if="showPromotionModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <h6>iReCall Brochures</h6>
        <div class="scroll-container" @scroll="onScroll('promotion')" style="max-height: 60vh;">
          <div class="entry-content clearfix">
            <div class="datatex-row-padding">
              <ul>
                <li>Our <a href="/iReCall Brochure.pdf" target="_blank" rel="noopener noreferrer">iReCall Brochure</a> highlights the key features of our product in a nutshell.</li>
                <br>
                <li>The <a href="/iReCall AQM Brochure 2024.pdf" target="_blank" rel="noopener noreferrer">iReCall AQM Brochure</a> contains comprehensive information on Agent Quality Management.</li>
                <br>         
                <li>Our <a href="/MS Teams Recording _ iReCall.pdf" target="_blank" rel="noopener noreferrer">MS Teams Recording</a> brochure outlines our call recording solution and its integration with Microsoft Teams.</li>
                <br>
                <li>Our <a href="/Cloud Archiving on iReCall.pdf" target="_blank" rel="noopener noreferrer">Cloud Archiving Brochure</a> highlights the advantages of storing your backups off-site and in the cloud.</li>
                <br>
              </ul>
            </div>
          </div>
        </div>
        <button class="close-button" @click="closeModal">Close</button>
      </div>
    </div>
  </div>
    <br>
    <br>
    <div class="page-break1"></div>
    <br>
    <br>
     <h5> <i class="fas fa-circle" style="color: red;"></i> iReCall YouTube Video Playlist.</h5>
      <br>
      <p style="font-size: 22px; color: #333;">Here is everything you need: a step-by-step <a href="https://www.youtube.com/playlist?list=PLnwEy2yO4kbtxwwOv0UJ5g38Y-dkoUcfp" target="_blank" rel="noopener noreferrer">iReCall Instructional Video</a> playlist from the Datatex YouTube channel.</p>
   </div>
  </section>
</div>
</template>

<script>
export default {
  name: 'IrecallView',
  data() {
    return {
      showPromotionModal: false,
      promotionScrollProgress: 0,
    };
  },
  methods: {
    openModal(modalName) {
      this.showPromotionModal = false;
      if (modalName === 'promotion') {
        this.showPromotionModal = true;
      }
    },
    closeModal() {
      this.showPromotionModal = false;
    },
    onScroll(modalName) {
      let scrollContainer = null;
        if (modalName === 'promotion') {
        scrollContainer = this.$el.querySelectorAll('.modal-overlay .scroll-container')[2];
        if (scrollContainer) {
          this.promotionScrollProgress = (scrollContainer.scrollTop / (scrollContainer.scrollHeight - scrollContainer.clientHeight)) * 100;
        }
      }
    }
  }
}
</script>

<style scoped>
.page-break {
 page-break-before: always;
 border: 1px solid red;
 width: 80%;
 margin-left: 10%;
 justify-content: center;
}
.page-break1 {
  page-break-before: always;
  border: 1px solid gray;
  width: 100%;
  justify-content: center;
}

.highlight {
      font-weight: bold;
      color: black;
}

ul li::marker {
  color: red;
  font-size: 1.5em;
}
a {
  position: relative;
  text-decoration: none;
  color: #2c4a66;
  font-weight: 500;
  transition: color 0.3s ease-in-out;
}

 a::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -3px;
  width: 100%;
  height: 2px;
  background-color: #000;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s ease-in-out;
}

 a:hover {
  color: #000;
}

 a:hover::after {
  transform: scaleX(1);
}

/* Typography */
/**************************/
#parallax-world-of-ugg h4 { 
 font-size:28px; 
 color:black;
 background-color: red;
 border-radius: 0 20px 0 20px ;
 color: white;
 padding: 8px; 
 margin:0;
}

#parallax-world-of-ugg h2 { 
 font-size:70px; 
 text-align:center; 
 color:white; 
 font-weight:400; 
 z-index:10; 
 opacity:.9;
}

#parallax-world-of-ugg h3 {
 color: white;
  font-size: 24px;
  background-color: maroon;
  padding: 5px;
}

h5 {
  font-size: 24px;
}

em {
  color: white;
  font-size: 20px;
  padding: 5px;
  font-weight: 400;
}

#parallax-world-of-ugg li { 
 font-weight:400; 
 font-size:20px; 
 line-height:30px;
   width: 90%;
  margin-left: 5%;
   text-align: justify;
  text-justify: inter-word;
}
.start-info { 
 font-weight:500; 
 font-size:22px; 
 line-height:30px;
 text-align: justify;
  text-justify: inter-word;
    width: 90%;
  margin-left: 5%;
}

.main-info { 
 font-size:19px; 
 line-height:10px;
 
}

span {
  color: red;
  font-weight:500; 

}

#circle-shape-example { 
  margin: 1rem; 
    width: 90%;
  margin-left: 5%;
}
#circle-shape-example p { 
  line-height: 1.6; 
}
#circle-shape-example .curve { 
  width: 280px; height: 260px;
  min-width: 150px;
  float: left;
  margin-right:3rem; 
  border-radius: 50%;
  -webkit-shape-outside:circle();
  shape-outside:circle();
  border: 5px solid red;
  box-shadow: 0 5px 20px #333;

}

/* Section - Title */
/**************************/
#parallax-world-of-ugg .title {
 background: white; 
 padding: 60px; 
 margin:0 auto; 
 text-align:center;
}

#parallax-world-of-ugg .title h1 {
 font-size:30px; 
 letter-spacing:5px;
}

/* Section - Block */
/**************************/
#parallax-world-of-ugg .block {
 background: white; 
 padding: 30px; 
 width:80%; 
 margin:0 auto; 
 text-align:left;
}

.img {
 text-align: center;

}

.img img {
 width: 400px;
}

.section-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  justify-content: space-between;
  width: 80%;
  margin-left: 10%;
}

.section-image {
  width: 400px;
  height: auto;
  margin-right: 20px;
  flex-shrink: 0;
  border-radius: 25px;
  box-shadow: 0 5px 20px #333;
  transition: .3s ease-in-out ;
}

.section-image:hover {
  transform: scale(1.1);
}

/* ----- Brochure ----- */

.buttton {
  display: flex;
  justify-content: center;
}

  .button {
    --width: 320px;
    --height: 80px;
    --tooltip-height: 35px;
    --tooltip-width: 90px;
    --gap-between-tooltip-to-button: 18px;
    --button-color: red;
    --tooltip-color: #fff;
    width: var(--width);
    font-size: 30px;
    height: var(--height);
    background: var(--button-color);
    position: relative;
    text-align: center;
    border-radius: 0 40px 0 40px ;
    box-shadow: 0 5px 30px red;
    transition: background 0.3s;
    transition: 0.3s ease-in-out;
    cursor: pointer;
  }
  .button:hover {
    border-radius:  40px 0  40px  0 ;
    box-shadow: 0 5px 50px maroon;

  }

  .button::before {
    position: absolute;
    content: attr(data-tooltip);
    width: var(--tooltip-width);
    height: var(--tooltip-height);
    background-color: var(--tooltip-color);
    font-size: 0.9rem;
    color: #111;
    line-height: var(--tooltip-height);
    bottom: calc(var(--height) + var(--gap-between-tooltip-to-button) + 10px);
    left: calc(50% - var(--tooltip-width) / 2);
  }

  .button::after {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-top-color: var(--tooltip-color);
    left: calc(50% - 10px);
    bottom: calc(100% + var(--gap-between-tooltip-to-button) - 10px);
  }

  .button::after,.button::before {
    opacity: 0;
    visibility: hidden;
    transition: all 0.5s;
  }

  .text {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .button-wrapper,.text,.icon {
    overflow: hidden;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    color: #fff;
  }

  .text {
    top: 0
  }

  .text,.icon {
    transition: top 0.5s;
  }

  .icon {
    color: #fff;
    top: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon svg {
    width: 50px;
    height: 50px;
  }

  .button:hover {
    background: maroon;
  }

  .button:hover .text {
    top: -100%;
  }

  .button:hover .icon {
    top: 0;
  }

  .button:hover:before,.button:hover:after {
    opacity: 1;
    visibility: visible;
  }

  .button:hover:after {
    bottom: calc(var(--height) + var(--gap-between-tooltip-to-button) - 20px);
  }

  .button:hover:before {
    bottom: calc(var(--height) + var(--gap-between-tooltip-to-button));
  }

/*--------- MODAL FOR BROCHURE ---------*/
h6 { 
 font-size:24px; 
 background-color: #2C4A66;
 color: white;
 padding: 8px; 
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content h3 {
  color: #2C4A66;
  border-bottom: #000 solid 3px;
}

.modal-content a {
  color: #2C4A66;
  text-decoration: none;
  font-weight: 500;
  transition: 0.3s ease-in-out;
}
.modal-content a:hover {
  color: #000;
  font-weight: 500;
}

.modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: 30px;
  transform: translate(-50%, -50%);
  background-color: white;
  color: black;
  padding: 20px;
  border-radius: 10px;
  width: 900px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  text-align: left;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  height: auto;
  overflow: visible;
}

.close-button {
  margin-top: 20px;
  background-color: #2C4A66;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer; 
  display: flex;
  justify-content: center;
  transition: 0.3s ease-in-out;
}

.close-button:hover {
  background-color: #02284b;
}

.scroll-container {
  overflow-y: auto;
  padding-right: 10px;
  position: relative;
  flex-grow: 1;
  scrollbar-width: thin;
  scrollbar-color: #2C4A66 #e0e0e0;
}

/* Custom scrollbar for WebKit browsers */
.scroll-container::-webkit-scrollbar {
  width: 8px;
}

.scroll-container::-webkit-scrollbar-track {
  background: #e0e0e0;
  border-radius: 10px;
}

.scroll-container::-webkit-scrollbar-thumb {
  background-color: #2C4A66;
  border-radius: 10px;
  border: 2px solid #e0e0e0;
}

/* Fading edges */
.scroll-container::before,
.scroll-container::after {
  content: "";
  position: sticky;
  left: 0;
  right: 0;
  height: 20px;
  pointer-events: none;
  z-index: 10;
}

.scroll-container::before {
  top: 0;
  background: linear-gradient(to bottom, white, transparent);
}

.scroll-container::after {
  bottom: 0;
  background: linear-gradient(to top, white, transparent);
}

/* Scroll progress bar */
.scroll-progress {
  position: absolute;
  top: 0;
  right: 0;
  width: 4px;
  background-color: #2C4A66;
  border-radius: 2px;
  transition: height 0.2s ease;
}

/* Media Queries */
/**************************/
@media screen and (max-width: 959px) and (min-width: 768px) {
 #parallax-world-of-ugg .block {
   padding: 40px; 
   width:620px;
 }
}
@media screen and (max-width: 767px) {
 #parallax-world-of-ugg .block {
   padding: 30px; width:420px;
 }
 #parallax-world-of-ugg h2 {
   font-size:30px;
 }
 #parallax-world-of-ugg .block {
   padding: 30px;
 }
 #parallax-world-of-ugg .parallax-one, #parallax-world-of-ugg .parallax-two, #parallax-world-of-ugg .parallax-three {
   padding-top:100px; 
   padding-bottom:100px;
 }
}
@media screen and (max-width: 479px) {
 #parallax-world-of-ugg .block {
  padding: 30px 15px; 
  width:290px;
 }
 #circle-shape-example .curve {
    width: 100px;
    height: 120px;
  }
  .section-flex {
    display: flex;
    flex-wrap: wrap;
  }
  .section-image {
    width: 200px;
  }
  #parallax-world-of-ugg li {
    font-size : 15px;
    line-height: 20px;
  }
  .start-info {
    font-size :18px;
    text-align: justify;
  }
  .modal-content {
    width: 350px;
    height: 430px;
    margin-top: 40px;
    }
    .img img {
      width: 100%;
    }
  }
</style>
